import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentDocumentService {
  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) {}

  /**
   * Obtener documentos de un alumno
   */
  getDocuments(userId: number, perPage: number = 50, filters?: any, params?: { product_id?: number; general_only?: boolean }): Observable<any> {
    let url = `${this.apiUrl}/student-document/index/${userId}/${perPage}`;
    const queryParams: string[] = [];
    if (filters) {
      queryParams.push(`filters=${encodeURIComponent(JSON.stringify(filters))}`);
    }
    if (params?.product_id) {
      queryParams.push(`product_id=${params.product_id}`);
    }
    if (params?.general_only) {
      queryParams.push(`general_only=1`);
    }
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }
    return this.http.get(url);
  }

  /**
   * Subir un nuevo documento
   */
  uploadDocument(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/student-document/store`, formData);
  }

  /**
   * Obtener un documento específico
   */
  getDocument(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/student-document/show/${id}`);
  }

  /**
   * Actualizar metadatos de un documento
   */
  updateDocument(id: number, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/student-document/update/${id}`, data);
  }

  /**
   * Eliminar un documento
   */
  deleteDocument(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/student-document/delete/${id}`);
  }

  /**
   * Verificar un documento
   */
  verifyDocument(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/student-document/verify/${id}`, {});
  }

  rejectDocument(id: number, feedback: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/student-document/reject/${id}`, { review_feedback: feedback });
  }

  /**
   * Descargar un documento
   */
  downloadDocument(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/student-document/download/${id}`, {
      responseType: 'blob'
    });
  }

  /**
   * Actualizar fecha de expiración del DNI
   */
  updateDniInfo(userId: number, data: { dni_expiration_date: string }): Observable<any> {
    return this.http.put(`${this.apiUrl}/user/update-dni/${userId}`, data);
  }

  /**
   * Subir imagen del DNI (parte delantera)
   */
  uploadDniFrontImage(userId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/user/upload-dni-front/${userId}`, formData);
  }

  /**
   * Subir imagen del DNI (parte trasera)
   */
  uploadDniBackImage(userId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/user/upload-dni-back/${userId}`, formData);
  }
}
